// The regions of the brain that take in each element family, shared by "What happens in the
// brain" and the five stages on How it works. Textbook anatomy (MNI coordinates), shown as where
// the brain receives each sense, not as a vimbal measurement.

// Data frame of the atlas: (MNI - [0.53, -17.77, 15.41]) * 0.016106, left hemisphere.
export const REGIONS = [
  { pos: [-0.427, -0.648, 0.654], color: [0.42, 0.78, 0.9], label: "Parietal cortex", role: "sense of place" }, // (-26,-58,56)
  { pos: [-0.782, -0.068, -0.119], color: [0.98, 0.6, 0.28], label: "Auditory cortex", role: "sound" }, // (-48,-22,8)
  { pos: [-0.492, -0.97, -0.442], color: [0.96, 0.36, 0.26], label: "Visual area V4", role: "color" }, // (-30,-78,-12)
  { pos: [-0.717, -0.809, -0.216], color: [0.6, 0.86, 0.42], label: "Visual area MT", role: "motion" }, // (-44,-68,2)
  { pos: [-0.717, -0.616, -0.474], color: [0.98, 0.84, 0.36], label: "Visual word form area", role: "reading" }, // (-44,-56,-14)
  { pos: [-0.782, 0.608, -0.055], color: [0.94, 0.52, 0.66], label: "Broca's area", role: "language" }, // (-48,20,12)
  { pos: [-0.878, -0.39, -0.023], color: [0.94, 0.52, 0.66], label: "Wernicke's area", role: "language" }, // (-54,-42,14)
];

// The convergence point's look: every region lit, the brain's copper wiring at a medium rhythm,
// fine enough that the glass cortex's folds show through (Josh, 29 Sep 2026). The five stages end
// on the same image (Josh, 30 Sep 2026).
export const CONVERGENCE = { hz: 16, calm: 0.7, tone: [0.86, 0.62, 0.36], gain: 0.46 };
